import { Box, Button, Stack, Typography, Collapse, Fade } from '@mui/material'
import MessageTrafficVolumeChart from 'molecules/MessageTraffic/MessageVolumeChart'
import { useEffect } from 'react'
import { useMessagesDashboardViewContext } from '../MessagesDashboardViewContext'

import { Visibility, VisibilityOff } from '@mui/icons-material'

export interface MessageVDashboardOverviewProps {
  isChartVisible?: boolean
  toggleChartVisibility?: () => void
}

export default function MessageDashboardOverview(props: MessageVDashboardOverviewProps) {
  const context = useMessagesDashboardViewContext()
  const { trafficChartVisible, toggleTrafficChartVisibility } = context

  // Use props if provided, otherwise use context
  const chartVisible =
    props.isChartVisible !== undefined ? props.isChartVisible : trafficChartVisible
  const toggleChart = props.toggleChartVisibility || toggleTrafficChartVisibility

  useEffect(function init() {
    context.searchMessagesTraffic()
  }, [])

  return (
    <Box>
      <Collapse in={chartVisible} timeout={300}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6" fontWeight="bold">
              Traffic Overview
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Message volume over time
            </Typography>
          </Stack>
          <Button
            variant="outlined"
            size="small"
            onClick={toggleChart}
            startIcon={chartVisible ? <VisibilityOff /> : <Visibility />}
            sx={{
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                transform: 'translateY(-1px)',
                boxShadow: 1,
              },
            }}
          >
            {chartVisible ? 'Hide Chart' : 'Show Chart'}
          </Button>
        </Stack>
      </Collapse>

      <Fade in={chartVisible} timeout={400}>
        <Box>{chartVisible && <MessageTrafficVolumeChart traffic={context.traffic} />}</Box>
      </Fade>
    </Box>
  )
}
